<template>
    <b-form-group id="input-group-type" label-size="md" :label="title">
        <date-range-picker ref="picker" opens="center"
            :locale-data="{ firstDay: 0, format: 'dd/mm/yyyy', separator: ' - ', applyLabel: 'Confirmar', cancelLabel: 'Cancelar', daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'], monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'] }"
            :singleDatePicker="false" :timePicker="false" :timePicker24Hour="false" :showWeekNumbers="false"
            :showDropdowns="true" :ranges="false" :autoApply="false" :dateRange="value" @update="updateValues"
            :linkedCalendars="false">
            <div slot="footer" slot-scope="data" class="slot">
                <div class="applyBtn">
                    <a @click="data.clickApply" class="btn btn-primary btn-sm">Aplicar</a>
                </div>
                <div class="clearBtn">
                    <a @click="clearRange" class="btn btn-secondary btn-sm">Limpar</a>
                </div>
            </div>
            <template #input="">
                <span style="margin-right:5px; font-weight:bold">
                    {{ formatData(value.startDate) }}
                </span>
                -
                <span style="margin-left:5px; font-weight:bold">
                    {{ formatData(value.endDate) }}
                </span>
            </template>
        </date-range-picker>
    </b-form-group>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { UtilsTS } from '@/utilsts';

export default {
    name: 'DateRangePickerBase',
    components: {
        DateRangePicker
    },
    mixins: [UtilsTS],
    props: ['value', 'title'],
    methods: {
        clearRange() {
            this.$emit('input', { startDate: null, endDate: null })
            if (this.$refs.picker) this.$refs.picker.togglePicker(false)
        },
        updateValues(newDate) {
            this.$emit('input', newDate)
        }
    }
}
</script>
<style scoped>
.daterangepicker .clearBtn {
    margin-left: auto;
    float: right;
}

.daterangepicker .applyBtn {
    margin-left: auto;
    float: right;
}

.daterangepicker .clearBtn a {
    padding: 5px 20px !important;
    margin-right: 15px;
    background-color: #666 !important;
    margin-top: 10px;
    margin-bottom: 10px;
}

.daterangepicker .applyBtn a {
    padding: 5px 20px !important;
    margin-right: 15px;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #27740e !important;
}

.daterangepicker .slot {
    width: 100%;
    border-top: #ccc 1px solid;
}

.vue-daterange-picker {
    width: 100%;
}
</style>
